module.exports = __webpack_public_path__ + "img/like.c875ae08.gif";